export default __webpack_public_path__ + "static/caseStudiesCta-aa70e3f2c5598da9c718aa7d81484a25.png";